export default __webpack_public_path__ + "static/media/PC3-1.869d6f39.png";